<template>
		<div class="comments" >
      <van-row class="my_like">
        <van-col span="24" v-if="is_list">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :finished-text="$t('onLoad.finished_text')"
            @load="onLoad"
            :offset="10"
          >
            <van-cell v-for="t in list" :key="t.id">
              <van-col span="24" class="my_like_type">
                <van-col span="6">
                  <van-image round width="3.5em" height="3.5em" :src="t.avatar" fit="cover"  @click="user_Jump(t.uid)"/>
                </van-col>
                <van-col span="18">
                  <van-col span="24">{{t.user_nickname}}</van-col>
                  <van-col span="24" class="my_like_time">{{t.addtime}}</van-col>
                </van-col>
                <van-col span="24" class="my_like_user">
                  <van-col span="2" class="my_like_xin"><img src="../assets/img/like.png"/></van-col>
                  <van-col span="21">{{ $t('other.Like_your_dynamic')}}</van-col>
                </van-col>
                <van-col span="24" class="my_like_bg" @click="like_href(t.zone_id)">
                  <van-col span="6" v-if="t.video_url"><video :src="t.video_url"></video></van-col>
                  <van-col span="6" v-else>
                    <van-image :src="t.img" fit="fill"/>
                  </van-col>
                  <van-col span="18" class="my_like_center">{{t.msg_content}}</van-col>
                </van-col>
              </van-col>
            </van-cell>
          </van-list>
        </van-col>
        <van-col span="24" v-else>
          <van-col span="24" class="no-data">
            <img src="../assets/img/zwsl.png"/>
          </van-col>
          <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
        </van-col>
      </van-row>
		</div>
</template>
<script>
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
  import { judgeIosAndroid } from '@/assets/js/models.js'
	import axios from 'axios'
	 export default {
    data() {
      return {
        finished: false,
        loading: false,
        is_list: true,
		    list:[],
        page:1,
      }
    },
		created: function() {
      this.list = []
			this.convert()
			document.title = this.$t('title.like')
		},
    methods: {
      onLoad() {
        this.convert()
      },
			convert: function() {
				const uid = this.$route.query.uid;
        const token = this.$route.query.token;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/system_message_api/bzone_like_list",{ params:{ uid:uid,token:token,page: this.page }}).then(res => {
					console.log(res.data.list);
          if (res.data.code == 1) {
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                this.list.push(res.data.list[i]);
              }
              this.is_list = true
              this.page = this.page + 1
              this.loading = false
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              this.finished =true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
				})
			},
      like_href (id){
        window.location.href="bogo://vue_like_href?id="+id;
      },
      user_Jump(uid){
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.homepage.postMessage(uid)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.homepage(uid)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/like.vue